/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/jobs/:job_id/sink_logs/request_export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiJobsJobIdSinkLogsRequestExportCacheKeys } from "./constants";
import type {
  PostIntegrationsDirectCdiJobsJobIdSinkLogsRequestExportProps,
  IntegrationsDirectCdiJobsJobIdSinkLogsRequestExportResult,
} from "./types";

export const postIntegrationsDirectCdiJobsJobIdSinkLogsRequestExport = reactQueryMutationAdapter(
  integrationsDirectCdiJobsJobIdSinkLogsRequestExportCacheKeys,
  ({
    jobId,
    downloadType,
  }: PostIntegrationsDirectCdiJobsJobIdSinkLogsRequestExportProps): Promise<IntegrationsDirectCdiJobsJobIdSinkLogsRequestExportResult> => {
    return fetch(
      `/integrations/direct/cdi/jobs/${jobId}/sink_logs/request_export`,
      "POST",
      { download_type: downloadType },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
